import React, { useCallback, useEffect, useState } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import DatetimeField from '../DatetimeField';
import CommonDateInput from '../DatetimeField/CommonDateInput';
import { useField } from 'formik';
import DatePicker from 'forms/fields/DatetimeField/DatePicker';
import FormError from 'forms/fields/FormError';
import { birthdayFormatFromUTC, dateWithLocalTime } from 'utils/dayjs';
import MobileDialogDateTimeField from 'forms/fields/DatetimeField/MobileDialogDateTimeField';
import PopoverDateTimeField from 'forms/fields/DatetimeField/PopoverDateTimeField';
import { useMobile } from 'utils/media';
import './index.sass';

const { block, el } = bem('form-field', 'birthday-field');

const MobilePopup = (props) => {
    const text = 'Выберите дату рождения';
    return <MobileDialogDateTimeField {...props} text={text} className={el('dialog')} />
}

const BirthdayField = ({ name = 'customerBirthday' }) => {

    const { isMobile } = useMobile();

    const [ _field, { value: fieldValue, error, touched }, { setValue: setFieldValue }] = useField({name,  type: 'input'});

    const tzValue = fieldValue ? dateWithLocalTime(fieldValue, true) : fieldValue;

    const [ value, setValue ] = useState(tzValue);

    useEffect(() => {
        if (value) {
            setFieldValue(birthdayFormatFromUTC(value));
        } else {
            setFieldValue(value);
        }

    }, [ value ]);

    const BirthdayDateInput = useCallback((props) => {
        return <CommonDateInput {...props} setValue={setValue} />
    }, []);

    return (
        <div className={ block() }>
            <DatetimeField Field={ DatepickerField } Popup={ isMobile ? MobilePopup : PopoverDateTimeField }
                           Input={ BirthdayDateInput } error={error && touched} value={value} setValue={setValue} placeholder={'Ваша дата рождения'}/>
            {error && touched && <FormError>{error}</FormError>}
        </div>
    );
};

const DatepickerField = ({onClose = () => {}, value, setValue, setSaveDisabled = () => {}}) => {
    const onChange = (utcDate) => {
        //todo: do something about it, preferably add OK button
        // if (getYearFromUTC(utcDate) === getYearFromUTC(value) || (value === null && new Date().getFullYear().toString() === getYearFromUTC(utcDate))) {
        //     onClose();
        // }
        setValue(utcDate);
        setSaveDisabled(false);
    }

    return <div className={el('datepicker-container')}>
        <DatePicker className={el('datepicker')} dates={ [] } selected={ [] } disablePast={ false } shouldDisableDate={ () => false }
                    onChange={onChange} date={value}
                    views={ [ 'year', 'day' ] } disableFuture={ true }/>
    </div>;
};

export default observer(BirthdayField);
